export * from './app-sidebar-header.component';



// WEBPACK FOOTER //
// ./src/app/shared/app-sidebar-header/index.ts